// extracted by mini-css-extract-plugin
export var createdDate = "_kn-1";
export var divider = "_kn-2";
export var headerDivider = "_kn-3";
export var messagesCard = "_kn-0";
export var messagesContainer = "_kn-7";
export var messagesContainerWrapper = "_kn-4";
export var pointerCapturingButtonBoxes = "_kn-a";
export var showLeftPanelButton = "_kn-9";
export var showMoreButton = "_kn-c";
export var showMoreButtonContainer = "_kn-b";
export var summaryTitle = "_kn-6";
export var systemMessageCardWrapper = "_kn-d";
export var topButtons = "_kn-8";
export var withPadding = "_kn-5";